import { isIOS } from '@/tools/helpers';
import { logger } from '@/tools/logger';
import { BLUETOOTH_ENABLE_RESULT } from '@/tools/consts';
import { nativeMethodCall } from '@/tools/nativeInterface';

export const vRShowVideoMono = monoVideoURI =>
	nativeMethodCall({
		method: 'nativeVRShowVideoMono',
		params: monoVideoURI,
		fallback: () => false,
	});
export const wifiReassoc = () => nativeMethodCall({ method: 'nativeWifiReassoc' });
export const appGetLog = bytes =>
	nativeMethodCall({
		method: 'nativeAppGetLog',
		params: bytes,
	});
export const appNeedsVolumeControl = () =>
	nativeMethodCall({
		method: 'nativeAppNeedsVolumeControl',
		fallback: () => false,
	});
export const batteryGetState = () =>
	nativeMethodCall({
		method: 'nativeBatteryGetState',
		transform: state => {
			if (new RegExp('"discharging').test(state) || new RegExp('^discharging').test(state)) {
				return 'discharging';
			}
			if (new RegExp('"charging').test(state) || new RegExp('^charging')) return 'charging';
			if (new RegExp('full').test(state)) return 'full';
			return 'unknown';
		},
		fallback: () => 'unknown',
	});
export const batteryGetLevel = () =>
	nativeMethodCall({
		method: 'nativeBatteryGetLevel',
		fallback: () => -1,
	});
export const augmentedRealityStart = jsonMarkerModelList =>
	nativeMethodCall({
		method: 'nativeARStart',
		params: [jsonMarkerModelList],
		fallback: () => false,
	});
export const augmentedRealityGetVersion = () =>
	nativeMethodCall({
		method: 'nativeARGetVersion',
		transform: version => {
			if (!version) return undefined;
			return version;
		},
	});
export const appStartOfflineAppCheck = () =>
	nativeMethodCall({
		method: 'nativeAppStartOfflineAppCheck',
	});
export const audioMute = state =>
	nativeMethodCall({
		method: 'nativeAudioMute',
		params: [state],
	});
export const audioCrankUp = state =>
	nativeMethodCall({
		method: 'nativeAudioCrankUp',
		params: [state],
	});
export const vRShowMono = monoImageURI =>
	nativeMethodCall({
		method: 'nativeVRShowMono',
		params: [monoImageURI],
		fallback: () => false,
	});
export const infoGetDeviceName = () =>
	nativeMethodCall({
		method: 'nativeInfoGetDeviceName',
		fallback: () => 'unkown',
	});
export const infoGetModel = () =>
	nativeMethodCall({
		method: 'nativeInfoGetModel',
		fallback: () => 'unkown',
	});
export const appGetVersion = () => {
	logger.log('Do nativeAppGetVersion');
	return nativeMethodCall({
		method: 'nativeAppGetVersion',
		fallback: () => 'unkown',
	});
};
export const appPreventSleep = toggle =>
	nativeMethodCall({
		method: 'nativeAppPreventSleep',
		params: [toggle],
	});
export const appGoBack = () =>
	nativeMethodCall({
		method: 'nativeAppGoBack',
	});
export const appExit = restart =>
	nativeMethodCall({
		method: 'nativeAppExit',
		params: [!!restart],
	});
export const appGetIsLoaner = () =>
	nativeMethodCall({
		method: 'nativeAppGetIsLoaner',
		fallback: () => false,
	});
export const appIsIOS = () =>
	nativeMethodCall({
		method: 'nativeIsIOSApp',
		transform: os => !!os && isIOS(),
		fallback: () => false,
	});
export const contentShare = url =>
	nativeMethodCall({
		method: 'nativeContentShare',
		params: [url],
		fallback: url => logger.log('native share url:' + url),
	});
export const contentShareText = text =>
	nativeMethodCall({
		method: 'nativeContentShareText',
		params: [text],
		fallback: text => logger.log('native share text:' + text),
	});
export const contentOpen = url =>
	nativeMethodCall({
		method: 'nativeContentOpen',
		params: [url],
		fallback: result => {
			if (result.match(/^mailto:/)) window.location.href = result;
			else window.open(result);
		},
	});
export const contentDownload = url =>
	nativeMethodCall({
		method: 'nativeContentDownload',
		params: [url],
		fallback: result => {
			logger.log('Warning: nativeContentOpen not implemented');
			document
				.createElement('a')
				.setAttribute('href', result)
				.setAttribute('download', '')
				.click();
			return true;
		},
	});
export const appGetExhibitionID = () =>
	nativeMethodCall({
		method: 'nativeAppGetExhibitionID',
	});
export const infoGetAPIVersion = () =>
	nativeMethodCall({
		method: 'nativeInfoGetAPIVersion',
		fallback: () => 0,
	});
export const infoGetOS = () =>
	nativeMethodCall({
		method: 'nativeInfoGetOS',
		fallback: () =>
			// prettier-ignore
			/* eslint-disable no-nested-ternary */
			/iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream
				? 'iOS'
				: /Android/.test(navigator.userAgent) && !window.MSStream
					? 'Android'
					: 'unkown',
	});
export const infoGetBluetoothMAC = () =>
	nativeMethodCall({
		method: 'nativeInfoGetBluetoothMAC',
		fallback: () => 'unkown',
	});
export const infoGetWifiMAC = () =>
	nativeMethodCall({
		method: 'nativeInfoGetWifiMAC',
		fallback: () => 'unkown',
	});
// v18 Bluetooth Perssion Handling
export const bluetoothEnable = () =>
	nativeMethodCall({
		method: 'nativeBluetoothEnable',
		fallback: () => window.nativeOnBluetoothEnable(BLUETOOTH_ENABLE_RESULT.notAvailable),
	});

export const bluetoothDoScan = yesno =>
	nativeMethodCall({
		method: 'nativeBluetoothDoScan',
		params: [isIOS() ? (yesno ? 1 : 0) : !!yesno],
	});

export const setBrightness = value =>
	nativeMethodCall({
		method: 'nativeSetBrightness',
		params: [value],
	});
export const audioIsHeadphonePlugged = () =>
	nativeMethodCall({
		method: 'nativeAudioIsHeadphonePlugged',
	});
export const infoSetDeviceName = name =>
	nativeMethodCall({
		method: 'nativeInfoSetDeviceName',
		params: [name],
		fallback: () => false,
	});
export const infoGetOSVersion = () =>
	nativeMethodCall({
		method: 'nativeInfoGetOSVersion',
		fallback: () => 'unkown',
	});

export const locationEnable = () => {
	nativeMethodCall({
		method: 'nativeLocationEnable',
		fallback: () => 'unkown',
	});
};
